export const PENSION = 'pension'
export const KNOWLEDGE = 'knowledge'
export const VACANCIES = 'motivation_and_health'
export const ADVERTISING = 'advertising'
export const LAW = 'law'
export const INSURANCE = 'insurance'
export const CREDIT_INFORMATION = 'credit_information'
export const FINANCING = 'financing'
